import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';
import { LoadingScreen } from './ui/spinner';

/**
 * Gate for every authenticated route. While Firebase is still restoring the
 * persisted session the status is `loading`, and redirecting then would throw a
 * signed-in user back to the login page on every refresh - so that case renders
 * a splash instead of making a routing decision.
 */
export function ProtectedRoute() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();

  if (status === 'loading') {
    return <LoadingScreen label="Restoring your session..." />;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
